<template>
  <div class="app">
    <navigation v-if="showNavigation" />
    <div class="app-container" :class="{ 'with-sidebar': showNavigation }">
      <main class="app-main">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Navigation from './components/Navigation.vue';

const route = useRoute();

// Hide navigation on login page
const showNavigation = computed(() => route.name !== 'Login');
</script>

<style scoped>
.app {
  min-height: 100vh;
  background: var(--io-shell);
}

.app-container {
  min-height: 100vh;
}

.app-container.with-sidebar {
  margin-left: var(--sidebar-width);
}

.app-main {
  max-width: 72rem;
  padding: 1.5rem 2rem;
}

.app-container:not(.with-sidebar) .app-main {
  max-width: none;
  padding: 0;
}

@media (max-width: 768px) {
  .app-container.with-sidebar {
    margin-left: 0;
  }

  .app-main {
    padding: 1rem;
  }
}
</style>
